import { css, styled } from 'styled-components';

import { Flex } from '../Flex';
import { Overlay } from '../Overlay';

type CursorProps = {
  disabled?: boolean;
};

const cursorStyle = css<CursorProps>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'initial')};
`;

const colorStyle = css<CursorProps>`
  color: ${({ theme, disabled }) => (disabled ? theme.colors.disabled.text : undefined)};
  & > small {
    color: ${({ theme, disabled }) => (disabled ? theme.colors.disabled.text : undefined)};
  }
`;

const Container = styled.div`
  display: inline-block;
`;

const StyledOverlay = styled(Overlay)`
  padding: ${({ theme }) => theme.designTokens.dropdownOverlayPaddingY} 0;
`;

const ItemContainer = styled.div`
  padding: ${({ theme }) => theme.designTokens.dropdownItemPaddingY}
    ${({ theme }) => theme.designTokens.dropdownItemPaddingX};
`;

const ItemGroupContainer = styled.div`
  & h6 {
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  }

  & > div:not(:first-child) {
    padding-left: ${({ theme }) => theme.space.component.x.l};

    small {
      font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
    }
  }
`;

const Item = styled(ItemContainer).attrs({ as: Flex.Row })<CursorProps>`
  ${colorStyle}
  ${cursorStyle}
  &:hover,
  &.hover {
    background: ${({ theme }) => theme.designTokens.dropdownItemHoverBackgroundColor};
  }
  &:focus,
  &.focus {
    background: ${({ theme }) => theme.designTokens.dropdownItemFocusBackgroundColor};
    outline: none;
  }

  &.focus.hover {
    background: ${({ theme }) => theme.designTokens.dropdownItemHoverFocusedBackgroundColor};
  }
`;

export const Styled = {
  Container,
  Overlay: StyledOverlay,
  Item,
  ItemContainer,
  ItemGroupContainer,
};
